var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.785 3.092 1.84 8.794c-1.088.405-1.081.968-.2 1.22l4.094 1.184 9.472-5.542c.448-.253.857-.117.52.16l-7.673 6.423H8.05h.002l-.283 3.914c.414 0 .597-.176.829-.384l1.988-1.793 4.136 2.833c.762.39 1.31.19 1.5-.655l2.715-11.866c.278-1.033-.425-1.501-1.153-1.196Z",
    fill: "#40B3E0"
  })));
};
export default SvgTelegram;